import type { ReactNode } from 'react';

export interface LabelProps {
  uiId: string;
  htmlFor?: string;
  required?: boolean;
  children: ReactNode;
}

/**
 * 欄位標籤。
 *
 * 原系統外觀：`label { display:inline-block; max-width:100%; margin-bottom:5px; font-weight:bold }`
 * （bootstrap.css:2509-2514）。
 *
 * 必填星號：`.required-label:before { content:"*"; color:red; display:inline }`
 * （style-ePortfolio.css:215-219）── 星號在文字「前面」，紅色。另有 `.required-star { color:red }`
 * （style-ePortfolio.css:204-206）給手寫星號用。兩者顏色都是關鍵字 red (#ff0000)，
 * 與 theme.css 的 --color-danger (#ed5565)、--color-alert (#ff0066) 都不同，
 * 所以這裡用 arbitrary value 並註明出處（§8.1 允許，條件是記錄來源）。【雛形值待實機校準】
 *
 * 無障礙：星號標 aria-hidden，因為它只是視覺標記；真正的「必填」語意要靠欄位本身的
 * required／aria-required。第一層欄位元件的契約沒有 required prop，所以那件事屬於
 * 第二層 FormGrid，不在這裡偷偷補。
 */
export function Label({ uiId, htmlFor, required = false, children }: LabelProps) {
  return (
    <label
      data-ui-id={uiId}
      htmlFor={htmlFor}
      className="mb-[5px] inline-block max-w-full font-bold text-ink"
    >
      {required ? (
        <span aria-hidden="true" className="text-[#ff0000]">
          *
        </span>
      ) : null}
      {children}
    </label>
  );
}
